import { render, staticRenderFns } from "./MessageComponent.vue?vue&type=template&id=4b77d626&"
import script from "./MessageComponent.vue?vue&type=script&lang=js&"
export * from "./MessageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports